export const CONSULTANT_CLASS_ID = 'CONSULTANT' as const
export const CUSTOMER_CLASS_ID = 'CUSTOMER' as const
